export default {
  no_mobile_app: 'Brak skonfigurowanej aplikacji mobilnej',
  mobile_app_not_live: 'Aplikacja mobilna nie jest aktywna',
};
